import { skeletonize } from "../../helpers/skeletonize";
import { Body } from "../body/Body";
import { IconButton } from "../icon-button/IconButton.Parts";
import {
  Container,
  PageButton,
  PageButtonsContainer,
  SkeletonProps,
  getFooterText,
} from "./Pagination.Parts";

const ArrowButtonSkeleton = skeletonize(IconButton);
const PageButtonSkeleton = skeletonize(PageButton);
const FooterTextSkeleton = skeletonize(Body);

export const PaginationSkeleton = ({
  hideSinglePage = false,
  footer = true,
}: SkeletonProps) => {
  return (
    <Container>
      {!hideSinglePage && (
        <PageButtonsContainer>
          <ArrowButtonSkeleton />
          <PageButtonSkeleton $selected={false} />
          <PageButtonSkeleton $selected={false} />
          <PageButtonSkeleton $selected={false} />
          <ArrowButtonSkeleton />
        </PageButtonsContainer>
      )}
      {footer && (
        <FooterTextSkeleton variant="xsmall">
          {getFooterText(1, 10, 100)}
        </FooterTextSkeleton>
      )}
    </Container>
  );
};
